const UPS_ONE_BALANCE_PROVIDERID = '103';
const USPS_ONE_BALANCE_PROVIDERID = '2';

const prioritize = (canPrioritize, prioritization) => {
  return {
    canPrioritize,
    prioritization,
  };
};

const prioritizeByUPSOneBalance = (providerA, providerB) => {
  const providerAIsUPS1B = providerA.labelProviderId === UPS_ONE_BALANCE_PROVIDERID;
  const providerBIsUPS1B = providerB.labelProviderId === UPS_ONE_BALANCE_PROVIDERID;
  const providerAIsUSPS1B = providerA.labelProviderId === USPS_ONE_BALANCE_PROVIDERID;
  const providerBIsUSPS1B = providerB.labelProviderId === USPS_ONE_BALANCE_PROVIDERID;

  if ((providerAIsUPS1B && providerBIsUPS1B) || (providerAIsUSPS1B && providerBIsUSPS1B)) {
    return prioritize(false);
  }

  if (providerAIsUPS1B) {
    return prioritize(true, -1);
  }

  if (providerBIsUPS1B) {
    return prioritize(true, 1);
  }

  if (providerAIsUSPS1B) {
    return prioritize(true, -1);
  }

  if (providerBIsUSPS1B) {
    return prioritize(true, 1);
  }

  return prioritize(false);
};

const prioritizeByAlphaNumeric = (providerA, providerB) => {
  const ups1BPrioritization = prioritizeByUPSOneBalance(providerA, providerB);
  if (ups1BPrioritization.canPrioritize) {
    return ups1BPrioritization;
  }

  if (providerA.name < providerB.name) {
    return prioritize(true, -1);
  }

  if (providerB.name < providerA.name) {
    return prioritize(true, 1);
  }

  return prioritize(true, 0);
};

export const getSortedSellerLabelProviderList = (sellerLabelProviderRateInfo) => {
  return [...sellerLabelProviderRateInfo].sort((providerA, providerB) => {
    return prioritizeByAlphaNumeric(providerA, providerB).prioritization;
  });
};
